import { HeaderActionButton } from "frontend/app-header/header-action-button/header-action-button";
import styles from "./right-header.module.css";
import { memo, useRef } from "react";
import { useAtom } from "jotai";
import { VisalizeBoardIcon } from "frontend/icons/icons";
import { SidepanelType, sidePanelType } from "state-atoms";
import { useHover } from "frontend/ui-components/floaters/use-hover";
import { Tooltip } from "frontend/ui-components/floaters/tooltip";
import classNames from "classnames";

export const AIMenuTrigger = memo(() => {
  const [_, setOpenedSidePanel] = useAtom(sidePanelType);
  const iconRef = useRef<HTMLDivElement>(null);
  const iconHover = useHover(iconRef);

  return (
    <HeaderActionButton
      className={classNames(styles.actionIcon, iconHover && styles.aiIcon)}
      onClick={() => setOpenedSidePanel(SidepanelType.aiPanel)}
      ref={iconRef}
      data-ai-trigger
    >
      <VisalizeBoardIcon />
      {iconHover && (
        <Tooltip
          design="monday"
          label={"AI Generator"}
          relativeTo={iconRef}
          side={"bottom"}
          customStyle={{ borderRadius: 3 }}
        />
      )}
    </HeaderActionButton>
  );
});

AIMenuTrigger.displayName = "AIMenuTrigger";
